import { useCallback, useContext, useEffect, useState } from 'react';
import { Table } from 'antd';

import { ContentSection } from '../../../../../../../shared/components';
import { PreliquidationStepButtons, Summary } from '../../../../shared/components';

import { GenericDataFormContext } from '../../../../shared/contexts/GenericDataForm';
import { StepTwoFormContext } from '../../contexts/StepTwoForm';

import { PreLiquidationStep } from '../../../../shared/interfaces';

import { formattedPrice } from '../../../../../../../shared/utils';
import { StepOneFormContext } from '../../../StepOne/contexts/StepOneForm';
import { useTableConfigurationData } from './hooks/useTableConfigurationData';

export const QuotasSelected = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const { setCurrentStep, listQuota, getListOfSelectedQuotas, loadPreliquidationState } = useContext(GenericDataFormContext);
  const { postPaymentMethod } = useContext(StepTwoFormContext);

  const { totalSelected } = useContext(StepOneFormContext);

  const { columns } = useTableConfigurationData()

  const handlerOnClick = useCallback(async () => {
    try {
      postPaymentMethod()      
      setCurrentStep(PreLiquidationStep.THREE);
    } catch (error) {}
  }, [setCurrentStep]);

  const handlerBackButtonOnClick = useCallback(async () => {
    try {
      setCurrentStep(PreLiquidationStep.ONE);
    } catch (error) {}
  }, [setCurrentStep]);

  useEffect(() => {
    getListOfSelectedQuotas();
  }, [getListOfSelectedQuotas]);

  return (
    <>
      <ContentSection title='Cuotas Seleccionadas' hasCard={false}>
        <Table
          bordered
          className='w-100'
          columns={columns}
          dataSource={listQuota}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: listQuota?.length,
            showTotal: (total) =>
              total === 1 ? 'Una cuota' : `${total} cuotas`,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100'],
            onChange: (page, pageSize) => {
              setCurrentPage(page);
              setPageSize(pageSize);
            },
          }}
          scroll={{ x: 'max-content' }}
        />
      </ContentSection>

      <Summary data={[{ label: "Total Premio", value: <b>{`$ ${formattedPrice(totalSelected.toString())}`}</b> }]}/>


      <PreliquidationStepButtons
        label='Continuar'
        onClick={handlerOnClick}
        showGoBack={loadPreliquidationState === undefined}
        onPressBackButton={handlerBackButtonOnClick}
      />
    </>
  );
};
